<div class="card-1" *ngIf="balanceInProgress">
  <div class="loader"></div>
</div>
<div class="product-wrapper row justify-content-start mt-3" [hidden]="balanceInProgress">
  <div class="col-12 col-md-4 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters price-label">
            <div class="col-12">
              <div class="singleFund col-12">
                <div class="w-99 product-wrapper">
                  <kendo-dropdownlist [formControl]="fundId" [data]="calsBalancesDetails" [valuePrimitive]="false"
                    [valueField]="'customerCode'" textField="customerName" tabindex="1"
                    [popupSettings]="{ height: 200, 'z-index': 1000 }" (selectionChange)="check($event)">
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <span class="template">{{ dataItem?.customerName }} [{{ dataItem?.customerCode }}]</span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span class="template"> {{ dataItem?.customerName }} [{{ dataItem?.customerCode }}] </span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                      <b class="text-end"> BDT {{ dataItem.balance | number : 2 : true }}</b>
                    </ng-template>
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 text-end d-flex align-items-center mb-4">
    <ul class="row no-gutters transaction-tab">
      <!-- (click)="goToTransaction('balanceTransaction')" -->
      <li class="col-12 create" [routerLink]="'/dashboard/equity/summary/' + paramInvestorCode + '/requests'">
        <span>Requests</span>
      </li>
    </ul>
  </div>
</div>
<div [hidden]="balanceInProgress">
  <div class="row no-gutters justify-content-start" *ngIf="portfolioUrl && transactionsUrl && downloadReports">
    <div class="d-flex item">
      <label [routerLink]="portfolioUrl" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <span>Portfolio</span>
      </label>
      <label [routerLink]="transactionsUrl" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <span>Transactions</span>
      </label>
      <label [routerLink]="downloadReports" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <span>Download Statements</span>
      </label>
    </div>
  </div>
  <div class="card-1">
    <router-outlet></router-outlet>
  </div>
</div>